module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7C2CX"))).then(() => parcelRequire('1iHdE'));